export const GET_MARKET_LIST = 'GET_MARKET_LIST';
export const GET_MARKET_LIST_SUCCESS = 'GET_MARKET_LIST_SUCCESS';
export const GET_MARKET_LIST_FAILED = 'GET_MARKET_LIST__FAILED';
